<template>
    <span>{{ order(params) }}</span>
</template>

<script>
    export default {
        name: 'CellRendererOrder',
        computed: {
          order() {
            return ( v ) => {
              return v.data.invoice_type == 'Job' ? 'PR-'+ v.value : 'OR-'+ v.value
            }
          }
        }
    }
</script>
